<template>
  <div class="w-100 d-inline-flex align-items-center">
    <base-switch v-model="model" on-text="FCP" off-text="FCP" />

    <BDXStatusModalFormFCPToggleDateModal
      v-model="date"
      :show="showModal"
      @update:show="(newShowModal) => (showModal = newShowModal)"
    />

    <slot />

    <a
      v-if="!!date"
      role="button"
      class="ml-auto small pr-3"
      @click.prevent="() => (showModal = !showModal)"
    >
      <b-icon icon="pencil"></b-icon>
    </a>
  </div>
</template>

<script>
import { defineComponent, ref, computed } from '@vue/composition-api'

import BDXStatusModalFormFCPToggleDateModal from './BDXStatusModalFormFCPToggleDateModal.vue'

export default defineComponent({
  name: 'BDXStatusModalFormFCPToggle',
  components: {
    BDXStatusModalFormFCPToggleDateModal
  },
  props: {
    value: Boolean,
    startDate: {
      type: String,
      default: null
    }
  },
  emits: ['input', 'update:start-date'],
  setup(props, { emit }) {
    const showModal = ref(false)

    const model = computed({
      get: () => props.value,
      set: (newValue) => {
        if (newValue) showModal.value = true

        emit('input', newValue)
      }
    })

    const date = computed({
      get: () => props.startDate,
      set: (newStartDate) => emit('update:start-date', newStartDate)
    })

    return {
      showModal,

      model,

      date
    }
  }
})
</script>
